import csvDownload from 'json-to-csv-export';

/**
 * Generic CSV export function that works with any type of chart data
 * @param data - Array of objects to export
 * @param filename - Name of the file (without .csv extension)
 * @param options - Optional configuration for export behavior
 */
export function exportToCSV(
    data: any[],
    filename: string,
    options?: {
        includeTimestamp?: boolean;
        separator?: string;
    }
) {
    if (!data || data.length === 0) {
        console.warn('No data to export');
        return;
    }

    const timestamp = options?.includeTimestamp ? '_' + new Date().toLocaleDateString() : '';
    const finalFilename = filename + timestamp + '.csv';

    const csvData = {
        data: data,
        filename: finalFilename
    };

    csvDownload(csvData);
}

/**
 * Transform rating data specifically for CSV export
 * Converts grouped ratings data into a flattened format suitable for CSV
 * @param grouped - Map of grouped rating data by date
 * @param includeDeltas - Whether to include star rating deltas
 */
export function transformDailyAverageRatingDataForCSV(
    grouped: Map<string, any>
): any[] {
    const transformed: any[] = [];

    grouped.forEach((value, date) => {
        const row: any = {
            date: date,
        };

        if (value.averageApple !== undefined) {
            row['Apple Daily Average'] = value.averageApple;
        }

        if (value.averageGoogle !== undefined) {
            row['Google Daily Average'] = value.averageGoogle;
        }

        transformed.push(row);
    });

    return transformed;
}

export function transformDailyDeltaRatingDataForCSV(
    grouped: Map<string, any>
): any[] {
    const transformed: any[] = [];

    grouped.forEach((value, date) => {
        const row: any = {
            date: date,
        };

        // Add Apple deltas by star rating
        if (value.appleDeltas && Array.isArray(value.appleDeltas)) {
            row['Apple 1★'] = value.appleDeltas[0] || 0;
            row['Apple 2★'] = value.appleDeltas[1] || 0;
            row['Apple 3★'] = value.appleDeltas[2] || 0;
            row['Apple 4★'] = value.appleDeltas[3] || 0;
            row['Apple 5★'] = value.appleDeltas[4] || 0;
        }

        // Add Google deltas by star rating
        if (value.googleDeltas && Array.isArray(value.googleDeltas)) {
            row['Google 1★'] = value.googleDeltas[0] || 0;
            row['Google 2★'] = value.googleDeltas[1] || 0;
            row['Google 3★'] = value.googleDeltas[2] || 0;
            row['Google 4★'] = value.googleDeltas[3] || 0;
            row['Google 5★'] = value.googleDeltas[4] || 0;
        }

        transformed.push(row);
    });

    return transformed;
}